import React from 'react';
import { get, filter, includes, orderBy, head, split, last } from 'lodash';
import { Loading, Text, Column, FlexContainer, OrderShippingEstimate, Row, Divider, Icon, If } from '../../../../../../../components/common';
import GetOrderById from '../../../../../../../components/graphql/getOrderById';
import GetCommentsbyOrderId from '../../../../../../../components/graphql/getOrderComments';
import { TIGERS_EYE } from '../../../../../../../utils/colors';
import { getIconTypeClient } from './headerInfoShared';

const styleCardOld = {
    backgroundColor: 'white',
    width: '100%',
    borderRadius: 8
};

const paddingElementsCardOld = {
    padding: '5px 10px 0px 10px'
};

const getElementsCardDeliveryOld = (data) => {
    return [
        {
            key: 'Nombre',
            value: `${get(data, 'customer.firstName')} ${get(data, 'customer.lastName')}`,
            active: true
        },
        {
            key: 'Email',
            value: get(data, 'customer.email', '-'),
            active: false
        },
        {
            key: 'Télefono',
            value: get(data, 'customer.phone', '-'),
            active: true
        },
        {
            key: 'Preferencia contacto',
            value: get(data, 'contactPreference', '-'),
            active: false
        }
    ];
};

const AuditHeaderInfoLegacy = ({ orderId, dataParent }) => {
    const getFormatDeliveryTime = (deliveryTime, anticipated) => {
        if (anticipated) {
            const splittedDeliveryTime = split(deliveryTime, '-');
            const shippingChange = get(dataParent, 'order.shippingChange');
            return shippingChange ? deliveryTime : `Antes de las ${last(splittedDeliveryTime)}`;
        }
        return deliveryTime;
    };

    const windowAnticipated = get(dataParent, 'order.windowAnticipated');
    const shippingChange = get(dataParent, 'order.shippingChange');

    return (
        <FlexContainer pT={20}>
            <GetOrderById variables={{ filters: [{ field: 'idOrder', value: orderId }] }}>
                {({ data, loading }) => {
                    return (
                        <Loading loading={loading}>
                            <FlexContainer width='100%' justify='space-between' gap={15}>
                                <Column style={styleCardOld}>
                                    <Row maxHeight='25px' justify='space-between' align='center' style={paddingElementsCardOld}>
                                        <Text text='Cliente' size={13} color='#333333' strong />
                                        {getIconTypeClient(data, 15, 16)}
                                    </Row>
                                    <Divider />
                                    <Column paddingVertical={5} paddingHorizontal={10} gap={5} style={{ flex: '0 1 auto' }}>
                                        {getElementsCardDeliveryOld(data).map(({ key, value, active }) => {
                                            return (
                                                <Row
                                                    key={key}
                                                    justify='space-between'
                                                    padding={5}
                                                    style={{
                                                        backgroundColor: active ? '#f4f4f5' : '',
                                                        borderRadius: active ? 8 : 0
                                                    }}
                                                >
                                                    <Text text={key} size={11} color='#333333' strong />
                                                    <Text text={value} size={11} color='#848484' />
                                                </Row>
                                            );
                                        })}
                                    </Column>
                                </Column>
                                <Column style={styleCardOld}>
                                    <Row maxHeight='25px' justify='space-between' align='center' style={paddingElementsCardOld}>
                                        <Text text='Envío' size={13} color='#333333' strong />
                                        {(!shippingChange && windowAnticipated) && <Icon name='clock-fast' color='#EB963C' size={18} />}
                                    </Row>
                                    <Divider />
                                    <Column paddingVertical={5} paddingHorizontal={10} gap={5} style={{ flex: '0 1 auto' }}>
                                        <Row justify='space-between' backgroundColor='#F4F4F5' style={{ borderRadius: 8 }} padding={5}>
                                            <Text text='Dirección:' size={11} color='#333333' strong />
                                            <Text text={`${get(data, 'customer.address.addressLine')}`} size={11} color='#848484' />
                                        </Row>
                                        <OrderShippingEstimate {...data}>
                                            {({ deliveryTime, deliveryDate }) => (
                                                <>
                                                    <Row justify='space-between' padding={5}>
                                                        <Text text='Entrega:' size={11} color='#333333' strong />
                                                        <Text text={deliveryDate} size={11} color='#848484' />
                                                    </Row>
                                                    <Row backgroundColor='#F4F4F5' style={{ borderRadius: 8 }} padding={5}>
                                                        <Text text='Promesa entrega:' size={11} color='#333333' strong />
                                                        <Row justify='flex-end'>
                                                            {!shippingChange && <If
                                                                condition={windowAnticipated}
                                                                then={<Icon name='clock-fast' size={18} right={3} color={TIGERS_EYE} />}
                                                            />}
                                                            <Text
                                                                text={getFormatDeliveryTime(deliveryTime, windowAnticipated)}
                                                                strong={shippingChange}
                                                                color={shippingChange ? '#5665f5' : '#848484'}
                                                            />
                                                        </Row>
                                                    </Row>
                                                </>
                                            )}
                                        </OrderShippingEstimate>
                                    </Column>
                                </Column>
                                <Column style={styleCardOld}>
                                    <GetCommentsbyOrderId variables={{ orderId }} fetchPolicy='network-only'>
                                        {({ data: commentsData, loading: commentsLoading }) => {
                                            const dataFilteredByDataSource = filter(commentsData, { dataSource: 'App' });
                                            const comments = filter(dataFilteredByDataSource, item => {
                                                return !includes(get(item, 'comment'), 'El Shopper,');
                                            });
                                            const lastShopperComment = head(orderBy(comments, 'createdAt', 'desc'));

                                            return (
                                                <Loading loading={commentsLoading}>
                                                    <Row maxHeight='25px'>
                                                        <Text
                                                            text='Comentario shopper'
                                                            size={13}
                                                            color='#333333'
                                                            strong
                                                            style={paddingElementsCardOld}
                                                        />
                                                    </Row>
                                                    <Divider />
                                                    <Row padding='5px 10px 5px 10px' style={{ flex: '0 1 auto' }}>
                                                        <Column backgroundColor='#f4f4f4' style={{ borderRadius: 8 }}>
                                                            <Text
                                                                text={get(lastShopperComment, 'comment', 'Sin comentarios')}
                                                                size={11}
                                                                color='#848484'
                                                                style={{
                                                                    maxHeight: '170px',
                                                                    overflowY: 'auto',
                                                                    padding: 5
                                                                }}
                                                            />
                                                        </Column>
                                                    </Row>
                                                </Loading>
                                            );
                                        }}
                                    </GetCommentsbyOrderId>
                                </Column>
                            </FlexContainer>
                        </Loading>
                    );
                }}
            </GetOrderById>
        </FlexContainer>
    );
};

export default AuditHeaderInfoLegacy;
